module.exports = __webpack_public_path__ + "static/media/logo_ministere_education_2024_1.c745f506.png";